var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMHat1MHair3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Man_x5F_headgear"
  }, /*#__PURE__*/React.createElement("g", {
    id: "headgear_x5F_3_2_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DC202F",
    d: "M490.8,215.3l-0.7-18.4c-1.1-16.8-0.5-19.9-6.6-22.4c-1.1-0.5-2.3-0.9-3.4-1.3 c-17-6.6-34.7-11.4-52.7-14.6c-3.2-0.6-6.4-1.1-9.6-1.6c-26.4-5.1-53.5-7.5-80.8-6.5c-3.4,0.1-6.9,0.3-10.3,0.6 c-29.8,2.3-59.4,8.3-86.4,20.5c-1.3,0.6-2.5,1.1-3.8,1.7c-2.7,1.3-9.9-0.1-4.4,51.6l0.1,3.7c1.2,10.3,5.5,12.2,9.8,10.5 c0.3-0.1,0.7-0.3,1-0.4c1.8-0.7,3.6-1.4,5.5-2c13.4-4.5,27.1-7.9,41-10.4c7-1.2,14-2.2,21.1-3c33.2-3.2,66.2-3.2,98.7,0.6 c6.5,0.7,12.9,1.6,19.4,2.8c12.6,2.2,25,5.2,37.2,9.1C478.2,239.8,492.4,247.6,490.8,215.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC202F",
    d: "M336.9,150.5c27.4-1,54.4,1.4,80.8,6.5c3.2,0.5,6.4,1,9.6,1.6c18,3.2,35.7,8,52.7,14.6 c0.1-2.8,0.2-5.7,0.1-8.5c-0.1-3.6-0.3-7.2-0.7-10.7c-2.8-26-13.5-53.1-32.4-71.6c-2.7-2.6-5.6-5.1-8.6-7.4 c-16.1-12.6-35.5-17.6-55.6-18.9c-3.3-0.2-6.7-0.3-10.1-0.4c-35.6,0.4-75,4.7-101.6,30.9c-2.8,2.6-5.4,5.3-7.8,8.2 c-17.6,21-24.4,49-23.2,76.7c27.1-12.2,56.6-18.1,86.4-20.5C330,150.8,333.5,150.6,336.9,150.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BA191F",
    d: "M475.7,168.3c-2.3-1.1-4.7-2.2-7-3.3c-15.7-7-32.1-12.7-49-17c-3.4-0.9-6.7-1.7-10.1-2.5 c-37.3-8.4-75.6-9.5-113.3-4.5c-3.4,0.5-6.8,1-10.2,1.6c-6.7,1.3-13.3,2.9-19.8,5c3.3-33.7,21-65.6,48.4-84.8 c0.1-0.1,0.3-0.2,0.4-0.3c-16.3,4.5-31.6,11.9-44,24.2c-2.8,2.6-5.4,5.3-7.8,8.2c-17.6,21-24.4,49-23.2,76.7 c27.1-12.2,56.6-18.1,86.4-20.5c3.4-0.2,6.9-0.4,10.3-0.6c27.4-1,54.4,1.4,80.8,6.5c3.2,0.5,6.4,1,9.6,1.6 c18,3.2,35.7,8,52.7,14.6c0-0.9,0.1-1.8,0.1-2.7C478.7,169.7,477.2,169,475.7,168.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BA191F",
    d: "M257.9,212.8c6.2-15.6,13.5-31.8,7.5-50.8c-8.6,2.6-17.1,5.7-25.3,9.5c-1.3,0.6-2.5,1.1-3.8,1.7 c-2.7,1.3-9.9-0.1-4.4,51.6l0.1,3.7c1.2,10.3,5.5,12.2,9.8,10.5c0.3-0.1,0.7-0.3,1-0.4c1.8-0.7,3.6-1.4,5.5-2 c4.5-1.5,9.1-2.9,13.7-4.2C259.4,226,255.9,218.8,257.9,212.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M363.8,44.5c-10.9-6.9-23.7,1.8-25.8,13.5c10.5-1.4,21.1-1.9,31.4-2.1C368.8,51.6,367.7,46.9,363.8,44.5z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M325.9,154.6c3.4-0.2,6.9-0.4,10.3-0.6c27.4-1,54.4,1.4,80.8,6.5c3.2,0.5,6.4,1,9.6,1.6 c21.4,3.8,42.3,9.8,62.1,18.4c-0.7-3.4-2.1-4.8-5.2-6.1c-1.1-0.5-2.3-0.9-3.4-1.3c-6.2-2.4-12.6-4.6-19-6.6l-0.3-7.8 c-3.5-34-15.2-62.7-38-87c22.6,24.7,32.2,53.9,35.5,87.2l0.3,6.9c-10.2-3-20.5-5.4-31-7.2l-0.7-7.2c-4-32.5-13.5-59.2-29.2-86.8 c15.4,27.8,22.9,55.1,26.7,87.1l0.6,6.5c-2.4-0.4-4.8-0.8-7.2-1.2c-9.2-1.8-18.4-3.2-27.7-4.3l-0.3-6.7 c-1.5-29.8-3.1-55.8-12.6-83.7c9.2,28.1,8.7,54,10.1,83.8l0.3,6.3c-9.6-1.1-19.3-1.7-29-2V144c-0.2-28.7-2.4-53-6.4-80.7 c3.6,27.8,3.8,52.1,3.8,80.7v6.3c-6.3-0.1-12.7-0.1-19.1,0.2c-3.4,0.1-6.9,0.3-10.3,0.6c-1.3,0.1-2.6,0.2-4,0.3l-0.4-5.8 c-1.7-28.4-1.9-53.5,8.3-79.9c-10.5,26.1-12.4,51.4-10.8,80c0.1,2,0.3,3.9,0.4,5.9c-10.5,1-21,2.5-31.3,4.6 c-0.3-1.8-0.6-3.7-0.8-5.6c-2.4-26.5,0.7-50,10.4-74.5c-10,24.3-15.3,47.6-12.9,74.8c0.2,2,0.5,3.9,0.8,5.8 c-7,1.5-14,3.2-20.8,5.3c-0.2-1.6-0.4-3.3-0.5-5c-1.6-24.4,2.2-45.6,9.5-68.6c-7.6,22.8-13.5,43.7-12,68.8 c0.1,1.9,0.4,3.7,0.6,5.5c-7.8,2.5-15.4,5.3-22.9,8.7c-1.3,0.6-2.5,1.1-3.8,1.7c-1.3,0.6-3.5,0.6-5,5.7c2.9-1.5,5.9-2.9,8.9-4.2 C267.2,162.7,296.4,156.9,325.9,154.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M409.4,219.6c-32.5-3.8-65.5-3.8-98.7-0.6c-7.1,0.8-14.1,1.8-21.1,3c-13.9,2.5-27.6,5.8-41,10.4 c-2.2,0.7-4.3,1.5-6.5,2.4c-2.3,0.9-4.6,1.9-6.9,3c1.8,2.1,4.2,2.2,6.6,1.3c0.3-0.1,0.7-0.3,1-0.4c1.8-0.7,3.6-1.4,5.5-2 c13.4-4.5,27.1-7.9,41-10.4c7-1.2,14-2.2,21.1-3c33.2-3.2,66.2-3.2,98.7,0.6c6.5,0.7,12.9,1.6,19.4,2.8c12.6,2.2,25,5.2,37.2,9.1 c7,2.2,14.5,5.6,19.5,2.7c-18.1-7.4-37-12.6-56.3-16C422.4,221.3,415.9,220.4,409.4,219.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M257.4,226.7c-6.5-17.8-5.4-33.9-4.5-51.7c-0.4,17.9,1.6,33.6,7.9,50.3l1.8,4.4l-3.3,1.6L257.4,226.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M281.5,220.8c-5.3-18.1-6.3-34.4-4.1-52.4c-1.7,18.1,2.4,33.9,7.6,51.2c0.5,1.6,1.1,3.1,1.6,4.6 l-3.4,1.3C282.6,224,282,222.4,281.5,220.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M309.3,216.5c-3.8-18.4-5.2-34.6-4.5-52.9c-0.1,18.4,4.3,33.9,8.2,52.1l1.1,4.9l-3.6,0.8L309.3,216.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M339.6,214.2c-3.1-18.9-1.4-35.3,1-53.5c-1.9,18.4-0.5,34.6,2.6,52.9l0.9,4.9l-3.6,0.8L339.6,214.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M371.2,213.6c2.7-18.8,4.9-35,3-53.7c2.4,18.5,3.3,35.1,0.7,54.2l-0.8,5.1l-3.6-0.6L371.2,213.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M406.1,216.6c3.9-18.2,5.6-34.7,2.2-53.1c3.9,18.1,5.2,34.9,1.4,53.9l-1.2,5l-3.6-1L406.1,216.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M440.3,222.5c2.6-17.5,3.8-32.9,0.6-50.3c3.7,17.1,5.5,32.7,3,50.8l-0.8,4.8l-3.6-0.7L440.3,222.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M465,228.1c3.4-16.9,6-31.8,4.7-48.9c1.9,17,2.3,32.3-1.1,49.7l-1,4.6l-3.6-0.9L465,228.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1888 -0.982 0.982 0.1888 187.3642 367.183)",
    fill: "#FFFEFE",
    cx: 315.9,
    cy: 70.2,
    rx: 3.2,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1887 -0.982 0.982 0.1887 154.9005 380.1993)",
    fill: "#FFFEFE",
    cx: 307.6,
    cy: 96.3,
    rx: 2.6,
    ry: 1.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1887 -0.982 0.982 0.1887 96.8757 372.9609)",
    fill: "#FFFEFE",
    cx: 274.2,
    cy: 127.8,
    rx: 2.6,
    ry: 1.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9996 -2.770315e-02 2.770315e-02 0.9996 -5.7586 7.536)",
    fill: "#FFFEFE",
    cx: 269.1,
    cy: 211.6,
    rx: 1.3,
    ry: 2.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9996 -2.770315e-02 2.770315e-02 0.9996 -4.5381 8.234)",
    fill: "#FFFEFE",
    cx: 294.9,
    cy: 167.9,
    rx: 1.6,
    ry: 3.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9787 -0.2051 0.2051 0.9787 -36.6884 64.4393)",
    fill: "#FFFEFE",
    cx: 292.5,
    cy: 209.2,
    rx: 1.6,
    ry: 3.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.989 -0.1478 0.1478 0.989 -24.4826 49.5251)",
    fill: "#FFFEFE",
    cx: 321,
    cy: 189.5,
    rx: 1.6,
    ry: 3.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1.770535e-02 -0.9998 0.9998 1.770535e-02 163.2301 489.4406)",
    fill: "#FFFEFE",
    cx: 330.7,
    cy: 161.6,
    rx: 3.1,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1.760553e-02 -0.9998 0.9998 1.760553e-02 183.8067 517.9119)",
    fill: "#FFFEFE",
    cx: 355.5,
    cy: 165.4,
    rx: 3.1,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1.770535e-02 -0.9998 0.9998 1.770535e-02 140.0582 553.0418)",
    fill: "#FFFEFE",
    cx: 351.5,
    cy: 205.2,
    rx: 3.1,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1.770535e-02 -0.9998 0.9998 1.770535e-02 204.2154 563.5311)",
    fill: "#FFFEFE",
    cx: 388.9,
    cy: 177.8,
    rx: 3.1,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1344 -0.9909 0.9909 0.1344 133.9848 569.0356)",
    fill: "#FFFEFE",
    cx: 392.7,
    cy: 207.8,
    rx: 3.1,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1343 -0.9909 0.9909 0.1343 171.3579 599.42)",
    fill: "#FFFEFE",
    cx: 428.7,
    cy: 201.6,
    rx: 3.1,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1 -6.399083e-03 6.399083e-03 1 -1.1643 2.9058)",
    fill: "#FFFEFE",
    cx: 453.5,
    cy: 183.4,
    rx: 1.6,
    ry: 3.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(7.002264e-02 -0.9975 0.9975 7.002264e-02 206.2377 656.9762)",
    fill: "#FFFEFE",
    cx: 455.5,
    cy: 217.9,
    rx: 3.1,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(8.397927e-03 -1 1 8.397927e-03 287.8992 663.7241)",
    fill: "#FFFEFE",
    cx: 478.6,
    cy: 186.7,
    rx: 3.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1396 -0.9902 0.9902 0.1396 132.4347 406.9185)",
    fill: "#FFFEFE",
    cx: 300.4,
    cy: 127.3,
    rx: 2.8,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3706 -0.9288 0.9288 0.3706 97.4454 317.2944)",
    fill: "#B4AAAB",
    cx: 282.8,
    cy: 86.7,
    rx: 3.5,
    ry: 1.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.232 -0.9727 0.9727 0.232 74.1404 346.8798)",
    fill: "#B4AAAB",
    cx: 256.7,
    cy: 126.5,
    rx: 3.5,
    ry: 1.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.899584e-02 -0.9996 0.9996 2.899584e-02 91.5079 396.2013)",
    fill: "#B4AAAB",
    cx: 249.7,
    cy: 151,
    rx: 3.5,
    ry: 1.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.899584e-02 -0.9996 0.9996 2.899584e-02 30.9823 437.3979)",
    fill: "#B4AAAB",
    cx: 240.6,
    cy: 202.8,
    rx: 3.5,
    ry: 1.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.889643e-02 -0.9996 0.9996 2.889643e-02 71.6217 442.1236)",
    fill: "#B4AAAB",
    cx: 263.4,
    cy: 184.2,
    rx: 3.2,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9825 -0.1865 0.1865 0.9825 -38.2984 49.0975)",
    fill: "#B4AAAB",
    cx: 241.8,
    cy: 228.1,
    rx: 1.3,
    ry: 2.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1 -9.097366e-03 9.097366e-03 1 -0.774 3.0604)",
    fill: "#FFFEFE",
    cx: 336,
    cy: 86.6,
    rx: 1.4,
    ry: 2.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1.860350e-02 -0.9998 0.9998 1.860350e-02 200.3094 458.8856)",
    fill: "#FFFEFE",
    cx: 333.9,
    cy: 127.4,
    rx: 2.8,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1.870329e-02 -0.9998 0.9998 1.870329e-02 274.85 449.2762)",
    fill: "#FFFEFE",
    cx: 366.3,
    cy: 84.6,
    rx: 2.8,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1.860350e-02 -0.9998 0.9998 1.860350e-02 254.0287 475.2008)",
    fill: "#FFFEFE",
    cx: 369.1,
    cy: 108.2,
    rx: 2.8,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9915 -0.1299 0.1299 0.9915 -7.3817 51.8277)",
    fill: "#FFFEFE",
    cx: 393.6,
    cy: 82.5,
    rx: 1.4,
    ry: 2.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9916 -0.1297 0.1297 0.9916 -13.3556 53.1261)",
    fill: "#FFFEFE",
    cx: 401.2,
    cy: 129.1,
    rx: 1.4,
    ry: 2.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9631 -0.2692 0.2692 0.9631 -11.6175 118.4836)",
    fill: "#FFFEFE",
    cx: 426.2,
    cy: 101.6,
    rx: 1.4,
    ry: 2.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9697 -0.2443 0.2443 0.9697 -20.2563 111.8812)",
    fill: "#FFFEFE",
    cx: 440.9,
    cy: 137.6,
    rx: 1.4,
    ry: 2.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9697 -0.2443 0.2443 0.9697 -14.1105 115.832)",
    fill: "#FFFEFE",
    cx: 459.9,
    cy: 114.8,
    rx: 1.4,
    ry: 2.8
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMHat1MHair3);
export default __webpack_public_path__ + "static/media/m-hat1_m-hair3.15576d7a374d98de620bfe6330df1ba3.svg";
export { ForwardRef as ReactComponent };